/**
 * Tracks Mixpanel page view events when routes change.
 * Separate from PageUrlCoordinator to maintain single responsibility principle.
 */
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { observer } from "mobx-react";
import pageViewTrackerStore from "../../../../stores/page-view-tracker-store";

const PageViewTracker = observer(() => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        pageViewTrackerStore.trackCurrentPageView(location.pathname, searchParams);
    }, [location, searchParams]);

    return null;
});

export default PageViewTracker;
